import React from 'react';
import { Grid } from '@material-ui/core';
import { ModalWrapper } from '../../../../components';

const modalName = 'vehiclesBuyFeesModal';

const VehicleFeesModal = ({ vehicles, type, rows }) => {
  if (!vehicles || !type) return null;
  const filteredVehicles = vehicles.filter(vehicle => vehicle.type === type);
  return (
    <ModalWrapper
      modalId={modalName}
      title={`Vehicle Fees (${rows.find(row => row.type === type) && rows.find(row => row.type === type).label})`}
      cancelText="Close"
      showSubmit={false}
    >
      <Grid container alignItems="center">
        <Grid item>
          <table style={{ minWidth: 500, textAlign: 'left', fontSize: 12 }}>
            <tr>
              <th>Vehicle</th>
              <th>Seller</th>
              <th>Fee</th>
              <th>Date</th>
            </tr>
            {filteredVehicles.map(vehicle => (
              <tr key={vehicle.id}>
                <td>
                  <a href={`/vehicles/${vehicle.id}/details`} target="_blank" rel="noopener noreferrer">
                    {vehicle.year} {vehicle.make} {vehicle.model}
                  </a>
                </td>
                <td>{vehicle.dealershipName}</td>
                <td>${vehicle.fee}</td>
                <td>{new Date(vehicle.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  weekday: 'short',
                  timeZone: 'America/Los_Angeles'
                })}</td>
              </tr>
            ))}
          </table>
        </Grid>
      </Grid>
    </ModalWrapper>
  );
};

export default VehicleFeesModal;
